document.addEventListener('DOMContentLoaded', () => {
  const radios = document.querySelectorAll("input[type='radio']");
  const unnavailablebuyButtons = document.querySelectorAll('.unnavailable-button');
  const availablebuyButtons = document.querySelectorAll('.available-button');

  if (radios.length !== 0) {
    radios.forEach((radio) => {
      radio.addEventListener('click', () => {
        if (radio.classList.contains('disabled')) {
          availablebuyButtons.forEach((button) => {
            button.classList.remove('tw-flex');
            button.classList.add('tw-hidden');
          });

          unnavailablebuyButtons.forEach((button) => {
            button.classList.remove('tw-hidden');
            button.classList.add('tw-flex');
          });
        } else {
          availablebuyButtons.forEach((button) => {
            button.classList.remove('tw-hidden');
            button.classList.add('tw-flex');
          });

          unnavailablebuyButtons.forEach((button) => {
            button.classList.remove('tw-flex');
            button.classList.add('tw-hidden');
          });
        }
      });
    });
  }
});
